var Curriculog = Curriculog || {};

Curriculog.UserRole = (function ($, _, Backbone, UserRole) {

	UserRole = Curriculog.CurriculogModel.extend({
        initilize: function () {
            console.log('here');
        }

    });
	return UserRole;

})($, _, Backbone, Curriculog.UserRole || {});
